import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] pb-[120px] w-full max-w-[600px] mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center py-10"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-white/70 py-10 font-sourcesanspro-regular"
}
const _hoisted_5 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-1 min-w-0" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "font-sourcesanspro-semibold text-base2 truncate" }
const _hoisted_10 = { class: "text-xs2 font-mono opacity-60 shrink-0" }
const _hoisted_11 = { class: "text-white/60 text-xs2 font-sourcesanspro-regular" }

import { IonButton, IonContent, IonFooter, IonIcon, IonRefresher, IonRefresherContent, RefresherCustomEvent, IonSpinner } from '@ionic/vue';
import { checkmarkCircle, time, warning } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useSafety, { Incident, IncidentStatus } from '@/modules/safety/composables/useSafety';
import BackButton from '@/shared/components/BackButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyReportsPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const { getMyReports } = useSafety();
const { reports, isFetchingReports, refetchReports } = getMyReports();

const onRefresh = async (ev: RefresherCustomEvent) => {
	await refetchReports();
	ev.target.complete();
};

const goToDetail = (r: Incident) => {
	router.push({ name: 'safety-my-report-detail', params: { id: r.id } });
};

const statusStyle = (status: IncidentStatus): string => {
	switch (status) {
		case 'resolved':
			return 'bg-green-600/20 text-green-300';
		case 'cancelled':
			return 'bg-gray-500/20 text-gray-300';
		case 'in_progress':
			return 'bg-yellow-500/20 text-yellow-200';
		case 'assigned':
			return 'bg-blue-500/20 text-blue-200';
		default:
			return 'bg-red-500/20 text-red-200';
	}
};

const statusIcon = (status: IncidentStatus) => {
	if (status === 'resolved' || status === 'cancelled') return checkmarkCircle;
	if (status === 'in_progress' || status === 'assigned') return time;
	return warning;
};

const formatDate = (iso: string) => new Date(iso).toLocaleString();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          class: "mt-8",
          slot: "fixed",
          onIonRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createVNode(TopBar, { class: "px-[34px]" }, {
          left: _withCtx(() => [
            _createVNode(BackButton, { to: "/safety" })
          ]),
          center: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('safety.my_reports')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (_unref(isFetchingReports) && !_unref(reports).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(IonSpinner), { name: "crescent" })
              ]))
            : (!_unref(reports).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('safety.no_reports_yet')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reports), (r) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: r.id,
                      class: "w-full min-h-[80px] rounded backdrop-blur-xl bg-white/10 text-white p-4 flex items-center gap-3 active:bg-white/20 text-left",
                      onClick: ($event: any) => (goToDetail(r))
                    }, [
                      _createVNode(_unref(IonIcon), {
                        icon: statusIcon(r.status),
                        class: "text-l2 shrink-0"
                      }, null, 8, ["icon"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)(`safety.types.${r.type}`)), 1),
                          _createElementVNode("span", _hoisted_10, "#" + _toDisplayString(r.public_code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(formatDate(r.created_at)), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-xs2 uppercase font-sourcesanspro-semibold px-2 py-1 rounded shrink-0", statusStyle(r.status)])
                      }, _toDisplayString(_unref(t)(`safety.status.${r.status}`)), 3)
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(NavigationBar, { "item-active": "safety" })
      ]),
      _: 1
    })
  ], 64))
}
}

})